module.exports = __webpack_public_path__ + "static/media/instagram-circle-border.c82a6ed0.svg";